export class IntervalTimer {
    constructor(callback, timeIntervalInMs) {
        this.callback = callback;
        this.timeIntervalInMs = timeIntervalInMs;
        this.timerId = null;
        this.paused = false;
        this.remainingTime = timeIntervalInMs;
        this.startTime = 0;
    }
    pause() {
        if (!this.paused && this.timerId !== null) {
            clearInterval(this.timerId);
            this.paused = true;
            this.remainingTime -= Date.now() - this.startTime;
        }
    }
    resume() {
        if (this.paused) {
            this.paused = false;
            this.startTime = Date.now();
            this.timerId = setTimeout(() => {
                this.run();
                this.timerId = setInterval(() => this.run(), this.timeIntervalInMs);
            }, this.remainingTime);
        }
    }
    clear() {
        clearInterval(this.timerId);
        this.timerId = null;
        this.paused = false;
        this.remainingTime = this.timeIntervalInMs;
    }
    start() {
        if (this.timerId === null) {
            this.timerId = setInterval(() => this.run(), this.timeIntervalInMs);
            this.startTime = Date.now();
        }
    }
    run() {
        this.callback();
        this.startTime = Date.now();
        this.remainingTime = this.timeIntervalInMs;
    }
}
//# sourceMappingURL=interval-timer.js.map